import { mapGetters } from 'vuex';
import format from '@/common/utilities/format';

export default {
    name: 'internetcableProvider',
    inject: ['$eventBus'],
    props: ['zipcode', 'state', 'city', 'show'],
    data() {
        return {
            loadIACPService: false,
        };
    },
    computed: {
        ...mapGetters('glb', ['glb']),
    },
    mounted() {
        let that = this;
        this.$eventBus.$on('initialize-iacp-service', function(){
            that.initializeIACPService();
        });
    },
    methods: {
        initializeIACPService() {
            if (this.loadIACPService) {
                return;
            }
            this.loadIACPService = true;
            let _eventBus = this.$eventBus;
            (function (w, d, s, o, f, js, fjs) {
                w['CM-TCWidget'] = o;
                w[o] = w[o] || function () { (w[o].q = w[o].q || []).push(arguments) };
                js = d.createElement(s),
                fjs = d.getElementsByTagName(s)[0];
                js.id = o;
                js.src = f;
                js.async = 1;
                fjs.parentNode.insertBefore(js, fjs);
                js.onload = () => {
                    $('#cmtcwidget').on('click', '.cmOfferCta', (e) => {
                        let providerType = '';
                        let linkName = e.target.href || e.target.parentElement.href || '';
                        console.log(linkName);
                        try {
                            providerType = $(e.target).closest('.cmAllData-offerCtaCol').siblings('.cmAllData-offerTypeCol').find('div').last().text();
                        } catch {
                            providerType = linkName;
                        }
                        _eventBus.$emit('ga', { en: 'telco_session', ec: 'partner', el: 'cordless', props: { link_name: format.capitalize(providerType) || 'provider selected' } });
                    });
                };
            }(window, document, 'script', 'cmtcw', 'https://cdn.cordlessmedia.com/telco/v1/widget.js'));
            cmtcw('message', {
                pid: '89984',
                zip: this.zipcode || '',
                address: this.glb.geo.address || '',
                city: this.city || '',
                state: this.state || '',
                apt: '',
                lat: ''+this.glb.geo.lat || '',
                long: ''+this.glb.geo.lng || '',
                linkColor: "#00494F",
                ctaButtonStyle: {
                    fontColor: "#fff",
                    buttonColor: "#00494F",
                    buttonHoverColor: "#00494fe6"
                },
                searchButtonStyle: {
                    fontColor: "#fff",
                    buttonColor: "#00494F",
                    buttonHoverColor: "#00494fe6"
                },
                // cancelButtonStyle: { //optional object config
                //     fontColor: "<Font color>",
                //     fontWeight: "<Font weight>",
                //     buttonColor: "<Button color>",
                //     buttonHoverColor: "<Button Hover Color>"
                // }
            });
        }
    },
};
